import React from 'react';
import styled from '@emotion/styled';

const MainBody = styled.div`
  border: 1px solid #e3edf3;
  border-radius: 10px;
  padding: 45px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background: white;

  @media (max-width: 56.25rem) {
    padding: 1rem;
  }
`;

const MainItem = styled.div`
  flex-basis: 40.5%;
  max-width: 40.5%;

  &:nth-of-type(odd) {
    flex-basis: 55.5%;
    max-width: 55.5%;
  }

  &:nth-of-type(1),
  &:nth-of-type(2) {
    margin-bottom: 20px;
  }

  &:nth-of-type(5) {
    margin-top: 20px;
  }

  h3 {
    font-size: 16px;
    font-weight: 500;
    color: ${(props) => props.theme.primaryColor};
    line-height: 1.6;
  }

  p {
    color: #0fcc98;
    font-size: 20px;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 1.7;
  }
`;

const formatNum = (num) =>
  num
    ? Number(num).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : '0.00';

const FxCard = ({
  currencySymbol,
  fxRate,
  tax,
  totalAmount,
  openingBalance,
  languageStatus,
  languageDictionary
}) => {

  return (
    <MainBody>
      <MainItem>
        <h3>Exchange rate</h3>
        <p>
          {currencySymbol} 1.00 = {currencySymbol} {fxRate || "1.00"}
        </p>
      </MainItem>

      <MainItem>
        <h3>Total Amount</h3>
        <p>
          {currencySymbol} {formatNum(totalAmount)}
        </p>
      </MainItem>

      <MainItem>
        <h3>Tax</h3>
        <p>
          {currencySymbol} {formatNum(tax)}
        </p>
      </MainItem>

      <MainItem>
        <h3>{languageStatus ? languageDictionary["para_current_balance"] : "Current Opening Balance"}</h3>
        <p>
         {formatNum(openingBalance)}
        </p>
      </MainItem>
    </MainBody>
  );
};

export default FxCard;
